import { Account } from '@tcs/client-portal-api/types/Account';
import { useQuery } from '@tcs/common/hooks/useQuery';

interface Props {
  loading: boolean;
  data?: Account[];
}

export const useAccounts = (options?: { enabled: boolean }): Props => {
  const { data, isLoading: loading } = useQuery<Account[], Error>(
    `/accounts`,
    options
  );

  return {
    loading,
    data,
  };
};

export default useAccounts;
